import React, { Component } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Button } from '@trevor/ui-components';
import AjaxSpinner from '../../AjaxSpinner';
import { post } from '../../../util/helpers/ajax-helpers';
import css from '../../../css/module/billing.css';
import flex from '../../../css/module/flex.css';

//
// Useful stripe test card: 4000008260003178 (asks for 3DS auth, and then fails with insufficient funds)
//
class UnpaidInvoices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paying: false,
      error: null,
    };
    this.pay = this.pay.bind(this);
  }

  pay() {
    const { onComplete, outstandingInvoice, stripeKey } = this.props;
    const { paymentMethod, clientSecret } = outstandingInvoice;
    this.setState({
      paying: true,
      error: null, // reset
    });
    post('initiating invoice payment', '/api/subscription/pay-invoice') // this is actually just for logging purposes
      .then(() => {
        loadStripe(stripeKey).then((stripe) => {
          stripe
            .confirmCardPayment(clientSecret, {
              payment_method: paymentMethod,
            })
            .then((result) => {
              if (result.error) {
                this.setState({
                  paying: false,
                  error: result.error.message,
                });
              } else {
                onComplete();
              }
            });
        });
      });
  }

  render() {
    if (this.state.paying) {
      return <AjaxSpinner small />;
    }

    return (
      <div
        className={`${flex.row} w-100 ${flex.alignItemsCenter} ${css.errorMessage}`}
      >
        {this.state.error ? (
          <div>
            Problem taking payment:
            <br />
            {this.state.error}
          </div>
        ) : (
          <div className={flex.alignItemsCenter}>
            You have an unpaid invoice. &nbsp;
            <Button variant="secondary" onClick={this.pay}>
              Pay now
            </Button>
            &nbsp;
            <Button
              variant="secondary"
              onClick={() =>
                window.open(this.props.outstandingInvoice.invoiceUrl, '_blank')
              }
            >
              View invoice
            </Button>
          </div>
        )}
      </div>
    );
  }
}

export default UnpaidInvoices;
